export type Country = {
  code: string;
  name: string;
  iso2?: string;
};

export const countries: Country[] = [
  { code: "AFG", name: "Afghanistan", iso2: "AF" },
  { code: "ALB", name: "Albania", iso2: "AL" },
  { code: "DZA", name: "Algeria", iso2: "DZ" },
  { code: "AND", name: "Andorra", iso2: "AD" },
  { code: "AGO", name: "Angola", iso2: "AO" },
  { code: "ATG", name: "Antigua and Barbuda", iso2: "AG" },
  { code: "ARG", name: "Argentina", iso2: "AR" },
  { code: "ARM", name: "Armenia", iso2: "AM" },
  { code: "AUS", name: "Australia", iso2: "AU" },
  { code: "AUT", name: "Austria", iso2: "AT" },
  { code: "AZE", name: "Azerbaijan", iso2: "AZ" },
  { code: "BHS", name: "Bahamas", iso2: "BS" },
  { code: "BHR", name: "Bahrain", iso2: "BH" },
  { code: "BGD", name: "Bangladesh", iso2: "BD" },
  { code: "BRB", name: "Barbados", iso2: "BB" },
  { code: "BLR", name: "Belarus", iso2: "BY" },
  { code: "BEL", name: "Belgium", iso2: "BE" },
  { code: "BLZ", name: "Belize", iso2: "BZ" },
  { code: "BEN", name: "Benin", iso2: "BJ" },
  { code: "BTN", name: "Bhutan", iso2: "BT" },
  { code: "BOL", name: "Bolivia", iso2: "BO" },
  { code: "BIH", name: "Bosnia and Herzegovina", iso2: "BA" },
  { code: "BWA", name: "Botswana", iso2: "BW" },
  { code: "BRA", name: "Brazil", iso2: "BR" },
  { code: "BRN", name: "Brunei", iso2: "BN" },
  { code: "BGR", name: "Bulgaria", iso2: "BG" },
  { code: "BFA", name: "Burkina Faso", iso2: "BF" },
  { code: "BDI", name: "Burundi", iso2: "BI" },
  { code: "KHM", name: "Cambodia", iso2: "KH" },
  { code: "CMR", name: "Cameroon", iso2: "CM" },
  { code: "CAN", name: "Canada", iso2: "CA" },
  { code: "CPV", name: "Cape Verde", iso2: "CV" },
  { code: "CAF", name: "Central African Republic", iso2: "CF" },
  { code: "TCD", name: "Chad", iso2: "TD" },
  { code: "CHL", name: "Chile", iso2: "CL" },
  { code: "CHN", name: "China", iso2: "CN" },
  { code: "COL", name: "Colombia", iso2: "CO" },
  { code: "COM", name: "Comoros", iso2: "KM" },
  { code: "COG", name: "Congo", iso2: "CG" },
  { code: "CRI", name: "Costa Rica", iso2: "CR" },
  { code: "HRV", name: "Croatia", iso2: "HR" },
  { code: "CUB", name: "Cuba", iso2: "CU" },
  { code: "CYP", name: "Cyprus", iso2: "CY" },
  { code: "CZE", name: "Czech Republic", iso2: "CZ" },
  { code: "DNK", name: "Denmark", iso2: "DK" },
  { code: "DJI", name: "Djibouti", iso2: "DJ" },
  { code: "DMA", name: "Dominica", iso2: "DM" },
  { code: "DOM", name: "Dominican Republic", iso2: "DO" },
  { code: "ECU", name: "Ecuador", iso2: "EC" },
  { code: "EGY", name: "Egypt", iso2: "EG" },
  { code: "SLV", name: "El Salvador", iso2: "SV" },
  { code: "GNQ", name: "Equatorial Guinea", iso2: "GQ" },
  { code: "ERI", name: "Eritrea", iso2: "ER" },
  { code: "EST", name: "Estonia", iso2: "EE" },
  { code: "ETH", name: "Ethiopia", iso2: "ET" },
  { code: "FJI", name: "Fiji", iso2: "FJ" },
  { code: "FIN", name: "Finland", iso2: "FI" },
  { code: "FRA", name: "France", iso2: "FR" },
  { code: "GAB", name: "Gabon", iso2: "GA" },
  { code: "GMB", name: "Gambia", iso2: "GM" },
  { code: "GEO", name: "Georgia", iso2: "GE" },
  { code: "DEU", name: "Germany", iso2: "DE" },
  { code: "GHA", name: "Ghana", iso2: "GH" },
  { code: "GRC", name: "Greece", iso2: "GR" },
  { code: "GRD", name: "Grenada", iso2: "GD" },
  { code: "GTM", name: "Guatemala", iso2: "GT" },
  { code: "GIN", name: "Guinea", iso2: "GN" },
  { code: "GNB", name: "Guinea-Bissau", iso2: "GW" },
  { code: "GUY", name: "Guyana", iso2: "GY" },
  { code: "HTI", name: "Haiti", iso2: "HT" },
  { code: "HND", name: "Honduras", iso2: "HN" },
  { code: "HUN", name: "Hungary", iso2: "HU" },
  { code: "ISL", name: "Iceland", iso2: "IS" },
  { code: "IND", name: "India", iso2: "IN" },
  { code: "IDN", name: "Indonesia", iso2: "ID" },
  { code: "IRN", name: "Iran", iso2: "IR" },
  { code: "IRQ", name: "Iraq", iso2: "IQ" },
  { code: "IRL", name: "Ireland", iso2: "IE" },
  { code: "ISR", name: "Israel", iso2: "IL" },
  { code: "ITA", name: "Italy", iso2: "IT" },
  { code: "JAM", name: "Jamaica", iso2: "JM" },
  { code: "JPN", name: "Japan", iso2: "JP" },
  { code: "JOR", name: "Jordan", iso2: "JO" },
  { code: "KAZ", name: "Kazakhstan", iso2: "KZ" },
  { code: "KEN", name: "Kenya", iso2: "KE" },
  { code: "KIR", name: "Kiribati", iso2: "KI" },
  { code: "KWT", name: "Kuwait", iso2: "KW" },
  { code: "KGZ", name: "Kyrgyzstan", iso2: "KG" },
  { code: "LAO", name: "Laos", iso2: "LA" },
  { code: "LVA", name: "Latvia", iso2: "LV" },
  { code: "LBN", name: "Lebanon", iso2: "LB" },
  { code: "LSO", name: "Lesotho", iso2: "LS" },
  { code: "LBR", name: "Liberia", iso2: "LR" },
  { code: "LBY", name: "Libya", iso2: "LY" },
  { code: "LIE", name: "Liechtenstein", iso2: "LI" },
  { code: "LTU", name: "Lithuania", iso2: "LT" },
  { code: "LUX", name: "Luxembourg", iso2: "LU" },
  { code: "MDG", name: "Madagascar", iso2: "MG" },
  { code: "MWI", name: "Malawi", iso2: "MW" },
  { code: "MYS", name: "Malaysia", iso2: "MY" },
  { code: "MDV", name: "Maldives", iso2: "MV" },
  { code: "MLI", name: "Mali", iso2: "ML" },
  { code: "MLT", name: "Malta", iso2: "MT" },
  { code: "MHL", name: "Marshall Islands", iso2: "MH" },
  { code: "MRT", name: "Mauritania", iso2: "MR" },
  { code: "MUS", name: "Mauritius", iso2: "MU" },
  { code: "MEX", name: "Mexico", iso2: "MX" },
  { code: "FSM", name: "Micronesia", iso2: "FM" },
  { code: "MDA", name: "Moldova", iso2: "MD" },
  { code: "MCO", name: "Monaco", iso2: "MC" },
  { code: "MNG", name: "Mongolia", iso2: "MN" },
  { code: "MNE", name: "Montenegro", iso2: "ME" },
  { code: "MAR", name: "Morocco", iso2: "MA" },
  { code: "MOZ", name: "Mozambique", iso2: "MZ" },
  { code: "MMR", name: "Myanmar", iso2: "MM" },
  { code: "NAM", name: "Namibia", iso2: "NA" },
  { code: "NRU", name: "Nauru", iso2: "NR" },
  { code: "NPL", name: "Nepal", iso2: "NP" },
  { code: "NLD", name: "Netherlands", iso2: "NL" },
  { code: "NZL", name: "New Zealand", iso2: "NZ" },
  { code: "NIC", name: "Nicaragua", iso2: "NI" },
  { code: "NER", name: "Niger", iso2: "NE" },
  { code: "NGA", name: "Nigeria", iso2: "NG" },
  { code: "NOR", name: "Norway", iso2: "NO" },
  { code: "OMN", name: "Oman", iso2: "OM" },
  { code: "PAK", name: "Pakistan", iso2: "PK" },
  { code: "PLW", name: "Palau", iso2: "PW" },
  { code: "PAN", name: "Panama", iso2: "PA" },
  { code: "PNG", name: "Papua New Guinea", iso2: "PG" },
  { code: "PRY", name: "Paraguay", iso2: "PY" },
  { code: "PER", name: "Peru", iso2: "PE" },
  { code: "PHL", name: "Philippines", iso2: "PH" },
  { code: "POL", name: "Poland", iso2: "PL" },
  { code: "PRT", name: "Portugal", iso2: "PT" },
  { code: "QAT", name: "Qatar", iso2: "QA" },
  { code: "ROU", name: "Romania", iso2: "RO" },
  { code: "RUS", name: "Russia", iso2: "RU" },
  { code: "RWA", name: "Rwanda", iso2: "RW" },
  { code: "KNA", name: "Saint Kitts and Nevis", iso2: "KN" },
  { code: "LCA", name: "Saint Lucia", iso2: "LC" },
  { code: "VCT", name: "Saint Vincent and the Grenadines", iso2: "VC" },
  { code: "WSM", name: "Samoa", iso2: "WS" },
  { code: "SMR", name: "San Marino", iso2: "SM" },
  { code: "STP", name: "Sao Tome and Principe", iso2: "ST" },
  { code: "SAU", name: "Saudi Arabia", iso2: "SA" },
  { code: "SEN", name: "Senegal", iso2: "SN" },
  { code: "SRB", name: "Serbia", iso2: "RS" },
  { code: "SYC", name: "Seychelles", iso2: "SC" },
  { code: "SLE", name: "Sierra Leone", iso2: "SL" },
  { code: "SGP", name: "Singapore", iso2: "SG" },
  { code: "SVK", name: "Slovakia", iso2: "SK" },
  { code: "SVN", name: "Slovenia", iso2: "SI" },
  { code: "SLB", name: "Solomon Islands", iso2: "SB" },
  { code: "SOM", name: "Somalia", iso2: "SO" },
  { code: "ZAF", name: "South Africa", iso2: "ZA" },
  { code: "KOR", name: "South Korea", iso2: "KR" },
  { code: "ESP", name: "Spain", iso2: "ES" },
  { code: "LKA", name: "Sri Lanka", iso2: "LK" },
  { code: "SDN", name: "Sudan", iso2: "SD" },
  { code: "SUR", name: "Suriname", iso2: "SR" },
  { code: "SWZ", name: "Swaziland", iso2: "SZ" },
  { code: "SWE", name: "Sweden", iso2: "SE" },
  { code: "CHE", name: "Switzerland", iso2: "CH" },
  { code: "SYR", name: "Syria", iso2: "SY" },
  { code: "TWN", name: "Taiwan", iso2: "TW" },
  { code: "TJK", name: "Tajikistan", iso2: "TJ" },
  { code: "TZA", name: "Tanzania", iso2: "TZ" },
  { code: "THA", name: "Thailand", iso2: "TH" },
  { code: "TGO", name: "Togo", iso2: "TG" },
  { code: "TON", name: "Tonga", iso2: "TO" },
  { code: "TTO", name: "Trinidad and Tobago", iso2: "TT" },
  { code: "TUN", name: "Tunisia", iso2: "TN" },
  { code: "TUR", name: "Turkey", iso2: "TR" },
  { code: "TKM", name: "Turkmenistan", iso2: "TM" },
  { code: "TUV", name: "Tuvalu", iso2: "TV" },
  { code: "UGA", name: "Uganda", iso2: "UG" },
  { code: "UKR", name: "Ukraine", iso2: "UA" },
  { code: "ARE", name: "United Arab Emirates", iso2: "AE" },
  { code: "GBR", name: "United Kingdom", iso2: "GB" },
  { code: "USA", name: "United States", iso2: "US" },
  { code: "URY", name: "Uruguay", iso2: "UY" },
  { code: "UZB", name: "Uzbekistan", iso2: "UZ" },
  { code: "VUT", name: "Vanuatu", iso2: "VU" },
  { code: "VAT", name: "Vatican City", iso2: "VA" },
  { code: "VEN", name: "Venezuela", iso2: "VE" },
  { code: "VNM", name: "Vietnam", iso2: "VN" },
  { code: "YEM", name: "Yemen", iso2: "YE" },
  { code: "ZMB", name: "Zambia", iso2: "ZM" },
  { code: "ZWE", name: "Zimbabwe", iso2: "ZW" },
  { code: "USDT", name: "Activo digital" },
  { code: "USDC", name: "USDC - Activo digital" },
];

